(function () {
  /* Wheel circumferences in metres */
  var WC = {
    '20x2.34':1.6489,'20x4':1.9139,'700cx2.35':2.3291,
    '26x2.35':2.1312,'26x4.5':2.4743,
    '27.5x2.35':2.2097,'27.5x4.5':2.5529,
    '29x2.6':2.3690
  };

  /* X1 Pro Gen 4: internal gear reduction per chainring option */
  var CR_REDUCTION = {'32':28.9, '38':34.4, '40':39.3};

  var CALCS = {
    'pim-x1-calc': {
      prefix:'x1', motorPowerW:6000, defaultCR:32
    },
    'pim-ph-calc': {
      prefix:'ph', motorPowerW:2000, defaultCR:34, rpmPerVolt:4.1667
    },
    'pim-x1-kit-calc': {
      prefix:'xk', motorPowerW:6000, defaultCR:32,
      batteries:{
        'A52':  {v:'52', wh:520},
        'A52L': {v:'52', wh:780},
        'A65':  {v:'65', wh:1296}
      },
      defaultBat:'A52',
      consumption:{eco:18, mixed:32, full:60}
    }
  };

  var states = {};

  function getState(calcId) {
    if (!states[calcId]) {
      var cfg = CALCS[calcId];
      var defaultV = '48';
      if (cfg.batteries && cfg.defaultBat && cfg.batteries[cfg.defaultBat]) {
        defaultV = cfg.batteries[cfg.defaultBat].v;
      }
      states[calcId] = {
        v: defaultV,
        cr: cfg.defaultCR,
        rc: 11,
        wh: '26x2.35',
        m: 'th',
        bat: cfg.defaultBat || ''
      };
    }
    return states[calcId];
  }

  function crankRpm(s, cfg) {
    if (cfg.rpmPerVolt) return parseInt(s.v) * cfg.rpmPerVolt;
    var motorRpm = parseInt(s.v) * 150;
    var reduction = CR_REDUCTION[String(s.cr)];
    return reduction ? motorRpm / reduction : motorRpm / 30;
  }

  function thKph(s, cfg) {
    return crankRpm(s, cfg) * (s.cr / s.rc) * WC[s.wh] * 60 / 1000;
  }

  function rwKph(s, cfg) {
    var rl = thKph(s, cfg) * 0.80;
    var kg=90.7, Cr=0.015, rh=1.22, Cd=0.4, g=9.81, ep=cfg.motorPowerW;
    var lo=0, hi=300;
    for (var i=0; i<60; i++) {
      var mid=(lo+hi)/2, vm=mid/3.6, P=(Cr*kg*g+0.5*rh*Cd*vm*vm)*vm;
      if (P < ep) lo=mid; else hi=mid;
    }
    return Math.min(rl, (lo+hi)/2);
  }

  function getEls(root, prefix) {
    var stats = root.querySelectorAll('.pim-stats .pim-sv');
    return {
      rpmv:       root.querySelector('#'+prefix+'-rpmv')       || root.querySelector('.pim-rpm b'),
      kph:        root.querySelector('#'+prefix+'-kph')        || root.querySelector('.pim-kph'),
      mph:        root.querySelector('#'+prefix+'-mph')        || root.querySelector('.pim-mph span') || root.querySelector('.pim-mph'),
      wrpm:       root.querySelector('#'+prefix+'-wrpm')       || stats[0] || null,
      gr:         root.querySelector('#'+prefix+'-gr')         || stats[1] || null,
      circ:       root.querySelector('#'+prefix+'-circ')       || stats[2] || null,
      rangeEco:   root.querySelector('#'+prefix+'-range-eco')  || null,
      rangeMixed: root.querySelector('#'+prefix+'-range-mid')  || null,
      rangeFull:  root.querySelector('#'+prefix+'-range-full') || null,
      batWh:      root.querySelector('#'+prefix+'-bat-wh')     || null,
      batVolt:    root.querySelector('#'+prefix+'-bat-volt')   || null
    };
  }

  function upd(calcId, rootEl) {
    var root = rootEl;
    if (!root) {
      var all = document.querySelectorAll('[id="'+calcId+'"]');
      root = all[all.length - 1] || null;
    }
    if (!root) return;
    var cfg = CALCS[calcId];
    var s   = getState(calcId);
    var els = getEls(root, cfg.prefix);
    try {
      var k   = s.m==='th' ? thKph(s, cfg) : rwKph(s, cfg);
      var mph = k / 1.60934;
      var cr  = Math.round(crankRpm(s, cfg));
      var gr  = s.cr / s.rc;
      var wr  = Math.round(k * 1000 / 60 / WC[s.wh]);
      if (els.rpmv) els.rpmv.textContent = cr;
      if (els.kph)  els.kph.textContent  = k.toFixed(1);
      if (els.mph)  els.mph.textContent  = mph.toFixed(1);
      if (els.wrpm) els.wrpm.textContent = wr;
      if (els.gr)   els.gr.textContent   = gr.toFixed(2)+':1';
      if (els.circ) els.circ.textContent = WC[s.wh].toFixed(3)+' m';
      if (cfg.batteries && cfg.consumption && s.bat) {
        var bat = cfg.batteries[s.bat];
        if (bat) {
          var wh = bat.wh;
          if (els.batWh)      els.batWh.textContent   = wh + ' Wh';
          if (els.batVolt)    els.batVolt.textContent  = bat.v + 'V';
          if (els.rangeEco)   els.rangeEco.textContent   = Math.round(wh / cfg.consumption.eco)   + ' km';
          if (els.rangeMixed) els.rangeMixed.textContent = Math.round(wh / cfg.consumption.mixed) + ' km';
          if (els.rangeFull)  els.rangeFull.textContent  = Math.round(wh / cfg.consumption.full)  + ' km';
        }
      }
    } catch(e) {}
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    var calcId = null, root = null;
    var node = target;
    while (node && node !== document) {
      if (node.id && CALCS[node.id]) { calcId = node.id; root = node; break; }
      node = node.parentNode;
    }
    if (!calcId) return;

    var s   = getState(calcId);
    var cfg = CALCS[calcId];

    if (target.classList.contains('pim-mbtn')) {
      var modeBtns = root.querySelectorAll('.pim-mode .pim-mbtn');
      var clickedIndex = -1;
      modeBtns.forEach(function(b, i) { if (b === target) clickedIndex = i; });
      if (clickedIndex === -1) return;
      s.m = clickedIndex === 0 ? 'th' : 'rw';
      modeBtns.forEach(function(b, i) { b.classList.toggle('on', i === clickedIndex); });
      upd(calcId, root);
      return;
    }

    if (target.classList.contains('pim-btn')) {
      var container = target.parentNode;
      if (!container) return;
      container.querySelectorAll('.pim-btn').forEach(function(b) { b.classList.remove('on'); });
      target.classList.add('on');

      var key, isInt;
      var cid    = container.id || '';
      var dash   = cid.indexOf('-');
      var suffix = dash !== -1 ? cid.slice(dash + 1) : '';

      if      (suffix === 'vol') { key = 'v';   isInt = false; }
      else if (suffix === 'cr')  { key = 'cr';  isInt = true;  }
      else if (suffix === 'rc')  { key = 'rc';  isInt = true;  }
      else if (suffix === 'whl') { key = 'wh';  isInt = false; }
      else if (suffix === 'bat') {
        s.bat = target.dataset.val;
        if (cfg.batteries && cfg.batteries[s.bat]) {
          s.v = cfg.batteries[s.bat].v;
        }
        upd(calcId, root);
        return;
      } else {
        var allGroups = root.querySelectorAll('.pim-btns');
        var groupIndex = -1;
        allGroups.forEach(function(g, i) { if (g === container) groupIndex = i; });
        var groupDefs = [
          {key:'v',  isInt:false},
          {key:'cr', isInt:true },
          {key:'rc', isInt:true },
          {key:'wh', isInt:false}
        ];
        var def = groupDefs[groupIndex];
        if (!def) return;
        key = def.key; isInt = def.isInt;
      }

      s[key] = isInt ? parseInt(target.dataset.val) : target.dataset.val;
      upd(calcId, root);
    }
  });

  function populateAll() {
    Object.keys(CALCS).forEach(function(calcId) {
      var all = document.querySelectorAll('[id="'+calcId+'"]');
      all.forEach(function(root) { upd(calcId, root); });
    });
  }

  populateAll();
  window.addEventListener('load', populateAll);
  setTimeout(populateAll, 500);
  setTimeout(populateAll, 1500);
  setTimeout(populateAll, 3000);
  setTimeout(populateAll, 6000);
})();
